import { useFormik } from 'formik';
import { useEffect } from 'react';
import { FunctionariesSwitch } from '../../../../../../shared/types/systemConfiguration/functionariesSwitch';

export const useFunctionariesSwitchData = (
    functionariesSwitch?: FunctionariesSwitch
) => {
    const formik = useFormik({
        initialValues: {
            name: '',
            surname: '',
            email: '',
            phone: '',
            extension: '',
            description: '',
            active: true,
            area: '',
            position: '',
        },
        onSubmit: console.log,
    });

    const areaName =
        typeof functionariesSwitch?.area === 'object' &&
        functionariesSwitch?.area?.name
            ? functionariesSwitch.area.name
            : '';

    const positionName =
        typeof functionariesSwitch?.position === 'object' &&
        functionariesSwitch?.position?.name
            ? functionariesSwitch.position.name
            : '';

    useEffect(() => {
        formik.setValues({
            name: functionariesSwitch?.name || '',
            surname: functionariesSwitch?.surname || '',
            email: functionariesSwitch?.email || '',
            phone: functionariesSwitch?.phone || '',
            extension: functionariesSwitch?.extension || '',
            active: functionariesSwitch?.active ?? false,
            area: areaName,
            position: positionName,
            description: functionariesSwitch?.description || '',
        });
    }, [functionariesSwitch]);

    return { formik };
};
